/**
 * Realistic spoken-duration estimate for avatar audio buttons ("Play … · m:ss").
 *
 * Uses ~80ms per character, which corresponds to roughly 150 wpm at an average
 * word length of ~5 characters — the pace the coach and the personas are authored
 * for. A 500ms lead-in accounts for the beat between button-tap and first
 * syllable. Minimum of 5 seconds so tiny notes don't produce absurd "0:01"
 * labels on a button.
 *
 * Mock.ts uses a faster pace (50ms/char) and caps segments at 8s — that's
 * deliberately tight for development feedback, not realistic audio timing.
 * The label shown to the learner reflects real-world speaking time, not
 * mock-playback time.
 */

const MS_PER_CHAR_SPOKEN = 80;
const LEAD_IN_MS = 500;
const MIN_SECONDS = 5;

export function estimateSpokenDuration(text: string): string {
  const ms = text.length * MS_PER_CHAR_SPOKEN + LEAD_IN_MS;
  const seconds = Math.max(MIN_SECONDS, Math.ceil(ms / 1000));
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
